import { Plus, X } from 'lucide-react';

/**
 * A list typed row by row: one input per item, «+ Добавить» for the next, a remove button on each.
 * Never empty: removing the last row leaves one blank. Blank rows are for the caller to drop (`filled`).
 */
export function RowsInput({ label, values, onChange, placeholder, addLabel = 'Добавить' }: { label: string; values: string[]; onChange: (v: string[]) => void; placeholder?: string; addLabel?: string }) {
  const rows = values.length ? values : [''];
  return (
    <fieldset className="min-w-0 space-y-1.5">
      <legend className="mb-1.5 text-sm font-semibold">{label}</legend>
      {rows.map((v, i) => (
        <div key={i} className="flex gap-1.5">
          <input className="field min-w-0 flex-1" aria-label={`${label} ${i + 1}`} placeholder={placeholder} value={v} onChange={(e) => onChange(rows.map((x, j) => (j === i ? e.target.value : x)))} />
          <button type="button" className="btn-ghost size-8 shrink-0 px-0" aria-label={`Удалить: ${label} ${i + 1}`} onClick={() => onChange(rows.length === 1 ? [''] : rows.filter((_, j) => j !== i))}>
            <X className="size-4" />
          </button>
        </div>
      ))}
      <button type="button" className="btn-ghost h-7 gap-1 px-2 text-xs" onClick={() => onChange([...rows, ''])}>
        <Plus className="size-3.5" /> {addLabel}
      </button>
    </fieldset>
  );
}
